import { IBrand } from "../Models/IBrand";
import { IBrandCategory } from "../Models/IBrandCategory";

export interface IGPSServiceAxios {
  GetBrands(): Promise<IBrand[]>;
  GetBrandById(brandId: string): Promise<IBrand>;
  GetCategories(): Promise<IBrandCategory[]>;
}
